import Seperator from '@components/std-components/Seperator'
import Typography from '@components/std-components/Typography'
import useOrderContext from '@modules/order/hooks/use-order-context'
import { stores, strings } from '@stores'
import { useObserver } from 'mobx-react-lite'
import React from 'react'
import Skeleton from 'react-loading-skeleton'
import * as css from './OrderTopBarBSGAndClient.css'

const OrderTopBarBSGAndClient: React.FC<any> = () => {
  return useObserver(function useHook() {
    const {
      uiStore: {
        dataStore: { summary, summaryLoading }
      }
    } = useOrderContext()
    const {
      nav: {
        queryParams: { orderType }
      }
    } = stores
    const buyingSessionGroupName =
      summary?.buyingSessionGroup?.name || strings.notAvailable
    const clientName =
      (orderType === 'door'
        ? summary?.clientOrder?.client?.name
        : summary?.client?.name) || strings.notAvailable

    return (
      <div className={css.wrapperContainer}>
        {!summaryLoading ? (
          <div className='flex align-center'>
            <div className={css.elementWrapper}>
              <Typography variant='subHeading1' classes={css['ellipsis-name']}>
                {clientName}
              </Typography>
            </div>
            <Seperator
              orientation='vertical'
              seperatorStyle='solid'
              seperatorColor='rgba(192,192,192,1)'
              size='20px'
              seperatorThickness='1px'
              margin='4px 16px 0 0'
            />
            <div className={css.elementWrapper}>
              <Typography variant='subHeading1' classes={css['ellipsis-name']}>
                {buyingSessionGroupName}
              </Typography>
            </div>
          </div>
        ) : (
          <Skeleton width='200px' height='20px' />
        )}
      </div>
    )
  })
}

export default OrderTopBarBSGAndClient
